import { FetchInterceptor } from "src/app/helpers/Index";
import { environment } from "src/environments/environment";

const endpoint = "TicketScan";

/** The turnstile. */
export const TicketScanService = {
	endpoint,
	redeem: async (data: any) => await FetchInterceptor(`${environment.server.apiURL}/${endpoint}/Redeem`, {body: JSON.stringify(data), headers: {"Content-Type": "application/json"}, method: "POST"}),
	summary: async (query: string) => await FetchInterceptor(`${environment.server.apiURL}/${endpoint}/Summary?${query}`, {headers: {"Content-Type": "application/json"}, method: "GET"})
};
